/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
export function parseTime(time, cFormat) {
  if (arguments.length === 0 || !time) {
    return null;
  }
  const format = cFormat || "{y}-{m}-{d} {h}:{i}:{s}";
  let date;
  if (typeof time === "object") {
    date = time;
  } else {
    if (typeof time === "string") {
      if (/^[0-9]+$/.test(time)) {
        // support "1548221490638"
        time = parseInt(time);
      } else {
        // support safari
        // https://stackoverflow.com/questions/4310953/invalid-date-in-safari
        time = time.replace(new RegExp(/-/gm), "/");
      }
    }

    if (typeof time === "number" && time.toString().length === 10) {
      time = time * 1000;
    }
    date = new Date(time);
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay(),
  };
  const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key];
    // Note: getDay() returns 0 on Sunday
    if (key === "a") {
      return ["日", "一", "二", "三", "四", "五", "六"][value];
    }
    return value.toString().padStart(2, "0");
  });
  return time_str;
}

/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime(time, option) {
  if (("" + time).length === 10) {
    time = parseInt(time) * 1000;
  } else {
    time = +time;
  }
  const d = new Date(time);
  const now = Date.now();

  const diff = (now - d) / 1000;

  if (diff < 30) {
    return "刚刚";
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + "分钟前";
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + "小时前";
  } else if (diff < 3600 * 24 * 2) {
    return "1天前";
  }
  if (option) {
    return parseTime(time, option);
  } else {
    return (
      d.getMonth() +
      1 +
      "月" +
      d.getDate() +
      "日" +
      d.getHours() +
      "时" +
      d.getMinutes() +
      "分"
    );
  }
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function param2Obj(url) {
  const search = decodeURIComponent(url.split("?")[1]).replace(/\+/g, " ");
  if (!search) {
    return {};
  }
  const obj = {};
  const searchArr = search.split("&");
  searchArr.forEach((v) => {
    const index = v.indexOf("=");
    if (index !== -1) {
      const name = v.substring(0, index);
      const val = v.substring(index + 1, v.length);
      obj[name] = val;
    }
  });
  return obj;
}

export function getUrlParam(url, paraName) {
  let arrObj = url.split("?");
  if (arrObj.length > 1) {
    let arrPara = arrObj[1].split("&");
    let arr;
    for (let i in arrPara) {
      arr = arrPara[i].split("=");
      if (arr != null && arr[0] == paraName) {
        return arr[1];
      }
    }
    return "";
  } else {
    return "";
  }
}

export function getHashParam() {
  // 获取完整的 URL
  const url = window.location.href;
  // 找到 # 符号的索引位置
  const hashIndex = url.indexOf("#");
  // 提取 # 之后的部分
  const hashPart = hashIndex !== -1 ? url.slice(hashIndex + 1) : "";
  // 找到 = 符号的索引位置
  const equalIndex = hashPart.indexOf("=");
  let paramValue = null;
  if (equalIndex !== -1) {
    // 获取等号后面的参数值
    paramValue = hashPart.slice(equalIndex + 1);
  }
  console.log(paramValue);
  return +paramValue;
}

export function getPathParam() {
  const typeObj = {
    platform: 1,
    channel: 2,
    merchant: 3,
    store: 4 
  }
  // 获取完整的 URL
  const url = window.location.href;
  let pathAfterLogin = ''
  const parts = url.split("/login");
  if (parts.length > 1) {
     pathAfterLogin = parts[1].slice(1);
  }
  const type = typeObj[pathAfterLogin]
  return +type;
}

export function getPathName() {
  const now = new Date()
  const formattedTime  = now.toLocaleString('zh-CN',  {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour12: false 
  })
  return formattedTime;
}

export function extractProvinceCityDistrict(address) {
  // 匹配省、市、区/县 
  const regex = /^([\u4e00-\u9fa5]+省|自治区|直辖市)?\s*([\u4e00-\u9fa5]+市)?\s*([\u4e00-\u9fa5]+(?:区|县|旗))/;
  const match = address.match(regex); 
  
  if (!match) return null;
  
  const [, province, city, district] = match;
  return [province, city, district].filter(Boolean).join(' ');
}
 
// const result = extractProvinceCityDistrict("广东省 深圳市 南山区前海大道2");
// console.log(result);  // 输出: 广东省 深圳市 南山区 